// extracted by mini-css-extract-plugin
export default {"buttons":"ConfirmationDialog_buttons__NIuEy"};